import {required, email} from './validation-logic';

export default {
	required: () => ([
		required()
	]),

	email: () => ([
		email()
	])
};
